import AlquilerRepository from '@/services/AlquilerRepository'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    alquiler: null,
  },
  mutations: {
    setAlquiler(state, alquiler) {
      if (alquiler) {
        alquiler.cantidadFormated = Vue.filter('fhNumber')(alquiler.cantidad)
        alquiler.importeTotalFormated = Vue.filter('fhNumber')(alquiler.importeTotal)
      }
      state.alquiler = alquiler
    },

    clearAlquiler(state) {
      state.alquiler = null
    },
  },
  actions: {
    async fetchAlquiler({state, commit, rootState}) {
      if (state.alquiler) {
        return
      }

      let idFichaAgricola = rootState.fichas.fichaAgricola.idFichaAgricola

      let alquiler = await AlquilerRepository.listaAlquiler(idFichaAgricola)
      commit('setAlquiler', alquiler)
    },

    clearAlquiler({commit}) {
      commit('clearAlquiler')
    },
  }
}
